compiler('[default-shipping-combination-sku-list]', (listContainer) => {
  let index = parseInt(listContainer.getAttribute('sku-list-initial-index'));
  const addButton = document.querySelector(`[add-sku-list-item="#${listContainer.id}"]`);
  const template = document.querySelector(`[sku-list-item-template="#${listContainer.id}"]`);


  addButton.addEventListener('click', (e) => {
    let newItem = template.cloneNode(true);
    newItem.innerHTML = newItem
        .innerHTML
        .replace(/{{index}}/g, index)
        .replace(/{{index\-plus\-one}}/g, index + 1);
    newItem = newItem.children[0];

    newItem.querySelectorAll('input').forEach(input => {
      input.removeAttribute('disabled');
    });

    listContainer.appendChild(newItem);
    index++;
  });
});

/* The remove button has to have his own compiler because
 * items are added dynamically and these button need to
 * get the event handler too
 */
compiler("[remove-sku-list-item]", (removeButton) => {
  removeButton.addEventListener('click', (event) => {
    document.getElementById(removeButton.getAttribute('remove-sku-list-item')).remove();
  });
});
